import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { freeBetStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';
// import { useTranslation } from '@pascal/pascal-core';
import {
  DECISIONS_MODELS,
  DOUBLE_BET_CODE,
  SPLIT_BEY_CODE,
  SURRENDER_TYPE,
} from '../../enums/constants';
import { turboGameService } from '../../services/TurboGameService';
import { doBetStore } from '../../store/doBetStore';
import { gameStore } from '../../store/gameStore';
import { ADDITIONAL_PARAMS_TYPE } from '../../enums/actionTypes';

const DecisionActionPanel = observer(({ possibleActions }) => {
  // const t = useTranslation();
  const { balance } = userInfoStore;
  const { lastBetModel } = doBetStore;
  const { activeBox } = gameStore;
  const { activeFreeBet } = freeBetStore;

  const isIncludesSplitOrDouble = useCallback(
    (type) => {
      return possibleActions.includes(type) || possibleActions.includes(type);
    },
    [possibleActions]
  );

  const isAllowDoubleOrSplit = useMemo(() => {
    const { betModel } = lastBetModel;
    const allowAmount =
      activeBox &&
      betModel
        ?.find((item) => item.boxIndex === activeBox)
        ?.markets?.find((market) => market.type === ADDITIONAL_PARAMS_TYPE.MAIN_BET)?.amount;
    return allowAmount <= balance;
  }, [lastBetModel, activeBox, balance]);

  const handleDecisionAction = useCallback((type) => {
    turboGameService.sendDecisionAction(type);
  }, []);

  return (
    <div className='tb-control-panel'>
      <div className='tb-action-btn-group'>
        {DECISIONS_MODELS.map(({ type, iconName, className }) => {
          let isPassiveInFreeChip = '';
          if (+type !== DOUBLE_BET_CODE && +type !== SPLIT_BEY_CODE) {
            isPassiveInFreeChip = '';
          } else if (activeFreeBet.id && !!activeFreeBet.remainingCount) {
            isPassiveInFreeChip = '';
          } else if (!activeFreeBet.id) {
            isPassiveInFreeChip = '';
          } else {
            isPassiveInFreeChip = 'passive';
          }
          let isPassiveInWithoutFreeChip = '';
          if (activeFreeBet.id) {
            isPassiveInWithoutFreeChip = '';
          } else if (isIncludesSplitOrDouble(type) && isAllowDoubleOrSplit) {
            isPassiveInWithoutFreeChip = '';
          } else if (+type === DOUBLE_BET_CODE || +type === SPLIT_BEY_CODE) {
            isPassiveInWithoutFreeChip = 'passive';
          }

          return possibleActions.includes(type) ? (
            <button
              type='button'
              className={`${className} ${isPassiveInWithoutFreeChip}
              ${isPassiveInFreeChip} ${type === SURRENDER_TYPE && activeFreeBet.id ? 'passive' : ''}
              `}
              onClick={() => handleDecisionAction(type)}
              key={type}
            >
              <span className={iconName} />
              {type === SURRENDER_TYPE && <i className='surrender-label'>50%</i>}
            </button>
          ) : null;
        })}
      </div>
    </div>
  );
});

export default DecisionActionPanel;
